import { render, staticRenderFns } from "./PointsBar.vue?vue&type=template&id=3fdd11f4&scoped=true&"
import script from "./PointsBar.vue?vue&type=script&lang=ts&"
export * from "./PointsBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdd11f4",
  null
  
)

export default component.exports